/** Client fallback helpers (same fields as server lib/productSearch). */

export function stripHtml(html) {
  if (!html || typeof html !== "string") return "";
  return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

export function buildCategoryNameMap(categories) {
  const map = {};
  (categories || []).forEach((c) => {
    if (c?.id) map[c.id] = c.categoryName || "";
  });
  return map;
}

function optionValueText(value) {
  if (value == null) return "";
  if (typeof value === "object") {
    return [value.name, value.hex, value.value].filter(Boolean).join(" ");
  }
  return String(value);
}

function pushPriceTokens(parts, price) {
  if (price == null || price === "") return;
  const n = Number(price);
  if (!Number.isFinite(n)) {
    parts.push(String(price));
    return;
  }
  parts.push(String(n), String(Math.round(n)), n.toFixed(2));
}

export function getProductSearchHaystack(product, categoryNameById = {}) {
  // Always use live fields. Stale `searchText` must not replace the name/SKU.
  const parts = [
    product.productName,
    product.productNameLower,
    product.skuId,
    product.id,
    product.productCategory,
    product.productUnit,
    stripHtml(product.description),
    typeof product.searchText === "string" ? product.searchText : "",
  ];

  pushPriceTokens(parts, product.productPrice);
  pushPriceTokens(parts, product.productDiscountedPrice);

  (product.sizes || []).forEach((s) => parts.push(s));

  (product.categories || []).forEach((catId) => {
    const name = categoryNameById[catId];
    if (name) parts.push(name);
    if (catId) parts.push(catId);
  });

  (product.variants || []).forEach((variant) => {
    if (variant?.optionName) parts.push(variant.optionName);
    (variant?.optionValue || []).forEach((v) => parts.push(optionValueText(v)));
  });

  (product.variantDetails || []).forEach((detail) => {
    if (detail?.sku) parts.push(detail.sku);
    pushPriceTokens(parts, detail.price);
    pushPriceTokens(parts, detail.discountedPrice);
    (detail?.combination || []).forEach((c) => {
      if (c?.name) parts.push(c.name);
      parts.push(optionValueText(c?.value));
      parts.push(optionValueText(c?.originalValue));
    });
  });

  return parts.filter(Boolean).join(" ").toLowerCase();
}

export function productMatchesSearch(
  product,
  searchTerm,
  categoryNameById = {}
) {
  const term = (searchTerm || "").toLowerCase().trim();
  if (!term) return true;
  const haystack = getProductSearchHaystack(product, categoryNameById);
  const tokens = term.split(/\s+/).filter(Boolean);
  return tokens.every((token) => haystack.includes(token));
}

export function sortProductsForSearch(products, searchTerm) {
  const term = (searchTerm || "").toLowerCase().trim();
  if (!term) return products;

  return [...products].sort((a, b) => {
    const aName = (a.productName || "").toLowerCase();
    const bName = (b.productName || "").toLowerCase();
    const aStarts = aName.startsWith(term) ? 0 : 1;
    const bStarts = bName.startsWith(term) ? 0 : 1;
    if (aStarts !== bStarts) return aStarts - bStarts;
    const aIncludes = aName.includes(term) ? 0 : 1;
    const bIncludes = bName.includes(term) ? 0 : 1;
    if (aIncludes !== bIncludes) return aIncludes - bIncludes;
    return aName.localeCompare(bName);
  });
}
